import { render, staticRenderFns } from "./ProductCoolSelect.vue?vue&type=template&id=145cd708&"
import script from "./ProductCoolSelect.vue?vue&type=script&lang=js&"
export * from "./ProductCoolSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductCoolSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports